import React from "react";
import { Redirect } from "react-router";
import classNames from "classnames";
import { Row, Col } from "reactstrap";
import { Icon } from "@cadmakers-ui/icons";
import iconStyles from "../../../../Common/Styles/Icons.module.scss";
import { appPaths } from "../../../../Common/Constants/appPaths";
import styles from "../../../Styles/SearchBarContainer.module.scss";
import { AppAutocompleteItem, AutocompleteItem } from "../../../Models/AutocompleteItem";

type Props = {
  item: AppAutocompleteItem;
  isRedirecting: boolean;
  isSelected: boolean;
  onClick?: (item: AutocompleteItem) => void;
  clearAutocompleteIfLoaded: () => void;
};

type State = {
  isRedirecting: boolean; // if this is true, this result will redirect to its app when it is rendered
};

export default class AppAutocompleteResult extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isRedirecting: props.isRedirecting === undefined ? false : props.isRedirecting
    };

    this.onClick = this.onClick.bind(this);
  }

  componentDidUpdate() {
    if (this.props.isRedirecting !== this.state.isRedirecting) {
      this.setState(prevState => {
        return {
          ...prevState,
          isRedirecting: this.props.isRedirecting
        };
      });

      // clear the autocomplete before we go
      this.props.clearAutocompleteIfLoaded();
    }
  }

  onClick() {
    // check if onClick is defined
    if (this.props.onClick) {
      // do the onclick
      this.props.onClick(this.props.item);
    } else {
      // no click handler defined
      // set this to redirect immediately
      this.setState(prevState => {
        return {
          ...prevState,
          isRedirecting: true
        };
      });
    }
  }

  getRedirectUrl(): string {
    return appPaths.app.root.replace(":id", this.props.item.code);
  }

  render() {
    if (this.state.isRedirecting) {
      // clear the autocomplete before we go
      this.props.clearAutocompleteIfLoaded();

      return <Redirect to={this.getRedirectUrl()} />;
    }
    const itemClasses = classNames(styles.autocompleteItem, {
      [styles.selected]: this.props.isSelected
    });

    return (
      <div className={itemClasses} onClick={this.onClick} title={this.props.item.itemName}>
        <div className={styles.autocompleteItemContents}>
          <Row>
            <Col xs={1} className={styles.itemIconCol}>
              <Icon
                appName="GeneralLayout"
                assetName="GENERAL_F_ListView"
                className={iconStyles.smallIcon}
              />
            </Col>
            <Col xs={11}>
              <div className={styles.autocompleteItemNameContainer}>{this.props.item.itemName}</div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
